// @flow
import {connect} from 'react-redux';
import FacebookIntegration from '../components/FacebookIntegration';
import {actions as ProductActions} from '../../../products/duck';
import {actions as UiActions} from '../../../ui/duck';
import {bindActionCreators} from 'redux';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    fbFeedToken: state.products.fbFeedToken,
    fetchFbFeedTokenError: state.products.fetchFbFeedTokenError,
    facebookIntegration: state.ui.facebookIntegration,
    isFetchingFacebookIntegration: state.ui.isFetchingFacebookIntegration,
    saveFacebookIntegrationSuccess: state.ui.saveFacebookIntegrationSuccess,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators({...ProductActions, ...UiActions}, dispatch)
)(FacebookIntegration);
